export default "__VITE_ASSET__Dr8C0RHj__"